import { isAllowed } from 'api/Apollo/allower';
import permissions from 'api/Apollo/permissions';

export default function isAllowedToCreateSchemas() {
  return isAllowed(permissions.createSchemas);
}
